<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseCell from 'dashboard/components/table/BaseCell.vue';
import { formatDuration } from '../../helpers/durationFormatHelper';

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const onlineDuration = computed(() => props.row.original.onlineDuration || 0);
const busyDuration = computed(() => props.row.original.busyDuration || 0);
const totalDuration = computed(() => onlineDuration.value + busyDuration.value);

const tooltip = computed(() => {
  const online = t('OVERVIEW_REPORTS.AGENT_STATUS.ONLINE');
  const busy = t('OVERVIEW_REPORTS.AGENT_STATUS.BUSY');
  return `${online} ${formatDuration(onlineDuration.value, t)} · ${busy} ${formatDuration(busyDuration.value, t)}`;
});
</script>

<template>
  <BaseCell>
    <div v-if="totalDuration" class="flex items-center justify-end gap-2">
      <div
        v-tooltip="tooltip"
        class="flex h-[7px] w-16 overflow-hidden rounded gap-px bg-n-slate-2 dark:bg-n-slate-1/30"
      >
        <span
          v-if="onlineDuration"
          class="h-full bg-n-teal-9"
          :style="{ flex: onlineDuration }"
        />
        <span
          v-if="busyDuration"
          class="h-full bg-n-amber-9"
          :style="{ flex: busyDuration }"
        />
      </div>
      <span class="text-sm font-medium text-n-slate-12 tabular-nums">
        {{ formatDuration(onlineDuration, t) }}
      </span>
    </div>
    <span v-else class="text-n-slate-10">---</span>
  </BaseCell>
</template>
